import { Constantes } from "../constants/constantsGlobal";
import { RequestChatBotProject } from "../models/interfaceChatBotProject";



export async function chatbotHealthCheck(request: RequestChatBotProject): Promise<any> {//Promise<paramChatbotResponse> {
  try {
    const response = await fetch(Constantes.URI_ChatbotHealthCheck, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'token': Constantes.HEADER_CHAT_BOT_TOKEN,  
      },
      body: JSON.stringify(request),  // Enviamos los parámetros directamente, sin anidarlos en "params"
    });

    if (!response.ok) {
      throw new Error('Error enviando el mensaje a la API');
    }

    //const data: paramChatbotResponse = await response.json();
    const data = await response.json(); 
    return data; 
  } catch (error) {
    console.error('Error al enviar el mensaje:', error);
    throw error;
  }
}


